import { Component, OnInit, Input, inject } from '@angular/core';
import { BmsCustomer } from '@app/features/bms/models/bms-customer';
import { Customer, GrpcNode } from '@xprojectorcore/xprojector_backend/proto/xprojector.grpc.models.pb';
import { NGXLogger } from 'ngx-logger';
import { BmsAdminService } from '@features/bms/bms-admin/services/bms-admin-service';
import { BmsApartment } from '@app/features/bms/models/bms-apartment';

@Component({
  selector: 'app-bms-admin-buildingaddress-view',
  templateUrl: './bms-admin-buildingaddress-view.component.html',
  styleUrls: ['./bms-admin-buildingaddress-view.component.scss']
})
export class BmsAdminBuildingaddressViewComponent implements OnInit {

  public adminService: BmsAdminService = inject(BmsAdminService);
  private logger: NGXLogger = inject(NGXLogger);


  private _bmsCustomer : BmsCustomer;
  @Input() set  bmsCustomer(value : BmsCustomer) {
    this._bmsCustomer = value;
    setTimeout(() => {
      //this.init();
    });
  }
  get bmsCustomer() : BmsCustomer {
    return this._bmsCustomer;
  }

  @Input() customer : Customer;

  _node : GrpcNode;
  @Input()
  set node(value : GrpcNode) {
    this._node = value;
    setTimeout(() => {
      this.init();
    });
  }
  get node() : GrpcNode {
    return this._node;
  }
  @Input() responsiveWidth: number = 834;


  apartments : BmsApartment[] = [];

  apartmentInfos : {floor : number; count : number; svLantNos : number[]; svLantNosString : string }[] = [];

  constructor() { }

  ngOnInit() {
  }

  async init() {
    let customerApartments = await this.adminService.getApartments(this.bmsCustomer.id);
    this.apartments = customerApartments.filter(x => x.buildingAddressId == +this.node.id);

    this.apartmentInfos = [];
    this.apartments.forEach(apt => {
      let apartmentInfo = this.apartmentInfos.find(x => x.floor == apt.floor);
      let svLantString = (apt.svlantApartmentno < 1000 ? '0' : '') + apt.svlantApartmentno;
      if (!apartmentInfo) {
        apartmentInfo = {floor : apt.floor, count : 1, svLantNos : [apt.svlantApartmentno], svLantNosString : svLantString};
        this.apartmentInfos.push(apartmentInfo);
      }
      else {
        apartmentInfo.count += 1;
        apartmentInfo.svLantNos.push(apt.svlantApartmentno);
        apartmentInfo.svLantNosString += ', ' + svLantString
      }
    });
    this.apartmentInfos.sort((a, b) => a.floor > b.floor ? 1 : -1);
  }
}
